export const commonConstants = {
  REFRESH_RATE: 60000,
  SYNC_RATE: 60000 * 5,
};

export const MineType = {
  AUDIO_WAV: 'audio/wav',
};
